import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputTextArea from '../../../FormFields/TextArea';
import Checkbox from '../../../FormFields/Checkbox';
import withConditionsAndTriggers from '../withConditionsAndTriggers';
import InputSelect from "../../../FormFields/Select";
import InputNumber from "../../../FormFields/Number";
import {VALIDATION_OPTIONS} from "../Text";
import Utils from "../../../../Services/Utils";

export class TextAreaWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api.getFieldsVerbiage(internalField, 'description') }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputText label='Placeholder' value={ internalField.placeholder }
                   onChange={ (v) => changeFieldValue('placeholder', v) }/>
        <InputSelect label='Validation' value={ internalField.validation }
                     onChange={ (v) => changeFieldValue('validation', v) } options={ VALIDATION_OPTIONS }/>
        <InputNumber label='Min Length' value={ internalField.minLength }
                   onChange={ (v) => changeFieldValue('minLength', v) }/>
        <InputNumber label='Max Length' value={ internalField.maxLength }
                   onChange={ (v) => changeFieldValue('maxLength', v) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
          <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('photo', v) } label='Photo'
                    checked={ internalField.photo }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, error, onChange, onError, api } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Text Area',
    };
    const validators = !Utils.isNull(field.validation) ? [
      (val) => {
        return !Utils.isNull(val) ? Utils.textValidator(field.validation, val) : null;
      }
    ] : [];
    return (
      <WrapperWidget {...props}>
        <div className='TextAreaWidget'>
          <InputTextArea
            disabled={ field.disabled }
            placeholder={ api ? api.getFieldsVerbiage(field, 'placeholder') : field.placeholder }
            required={ field.required }
            validators={ validators }
            value={value}
            onChange={onChange}
            onError={onError}
            error={error}
            minlength={ field.minLength }
            maxlength={ field.maxLength }
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const TextAreaWidgetEditable = withConditionsAndTriggers(TextAreaWidget);